export default "__VITE_ASSET__3CJNvV1U__"